











import { Vue, Component } from 'vue-property-decorator';

@Component
export default class bindRobot extends Vue {
    activeName: string = '';
    created() {
        this.getActiveTab();
    }
    getActiveTab() {
        const routeName = this.$route.name;
        this.activeName = routeName;
    }
    handleChangeTab() {
        this.$router
            .push({
                name: this.activeName,
                query: {
                    rgId: `${this.rgId}`
                }
            })
            .catch(e => e);
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
